// extracted by mini-css-extract-plugin
module.exports = {"text":"components-ResetPasswordEmail-ResetPasswordEmail__text--2hQ_r"};